/* eslint-disable max-lines-per-function */
import { connect } from 'react-redux';
import React, { useEffect, useRef } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { isTripord } from '../../../../utils/consts/general';
const ticketButtons = (props) => {
  const print = useRef(props.refrence);
  useEffect(() => {
    print.current = props.refrence;
  }, [props.refrence]);
  const downLoadPDF = () => {
    const { name } = props.language;
    const baseUrl = isTripord
      ? `${process.env.REACT_APP_API_TRIPORD_URL}/tripord-ticket/download/${name}/${props.id}`
      : `${process.env.REACT_APP_API_TRIPSI_URL}/tripsi-ticket/download/${name}/${props.id}`;
    window.open(baseUrl, '_blank');
  };
  return (
    <div
      className="border bg-white d-flex border-radius-xl mt-3 "
      style={{ borderRadious: '1rem' }}
    >
      <div
        className="col-6 border-left cursor-pointer border-right d-flex justify-content-center py-3"
        onClick={() => downLoadPDF()}
      >
        <FormattedMessage id="booking.downloadticket" />
      </div>

      <div className="col-6 d-flex justify-content-center py-3">
        <FormattedMessage id="booking.emailticket" />
      </div>
    </div>
  );
};

function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(connect(mapStateToProps, {})(ticketButtons));
